import React, { useState, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from 'react-hook-form';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import FormControl from '@material-ui/core/FormControl';
import DateRangePickerML from '@/components/DateRangePickerML';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import dayjs from 'dayjs';
import {
  Box,
  // FormControl,
  // MenuItem,
  // Select,
  // InputLabel,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { useIntl } from 'umi';
import SearchGroupStyled from './SearchGroupStyled';

const SearchGroup = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  //查询参数
  const { setSearchParam } = props;
  const [isReset, setIsReset] = useState(false);
  const [sendReset, setSendReset] = useState(false);
  const searchRef = useRef();
  //重置
  const handleReset = () => {
    setCardCodeValue('');
    // setCouponIdValue('');
    setMobileValue('');
    setIsReset(true);
    setSendReset(true);
    // setDate({ defaultStartDate: '', defaultEndDate: '' });
    reset({
      mobile: '',
      couponId: '',
      cardCode: '',
      date: {
        startDate: null,
        endDate: null,
      },
      sendDate: {
        sendStartTime: null,
        sendEndTime: null,
      },
    });
    setSearchParam({
      consumeEndTime: null,
      consumeStartTime: null,
      sendStartTime: null,
      sendEndTime: null,
      couponId: '',
      mobile: '',
      cardCode: '',
      pageSize: '10',
      pageNum: '1',
    });
  };

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    // register,
  } = useForm({});
  //单项置空
  const [cardCodeValue, setCardCodeValue] = useState();
  const [mobileValue, setMobileValue] = useState();
  // const [couponIdValue, setCouponIdValue] = useState();

  return (
    <SearchGroupStyled>
      <form
        onSubmit={handleSubmit((values) => {
          const val = {
            consumeEndTime: values.date?.endDate,
            consumeStartTime: values.date?.startDate,
            sendStartTime: values.sendDate?.startDate,
            sendEndTime: values.sendDate?.endDate,
            couponId: values.couponId,
            mobile: values.mobile,
            cardCode: values.cardCode,
            refreshTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            pageSize: '10',
            pageNum: '1',
          };
          window.NE_DAWN.trigger(searchRef.current, {
            event: '_ec', // 事件名
            params: { ...val }, // 事件公参
          });
          setSearchParam(val);
        })}
      >
        <Box className="search-wrapper">
          <Box className="left">
            <Box className="line">
              <FormControl variant="standard">
                <Controller
                  render={(rp) => (
                    <DateRangePickerML
                      label="核销时间"
                      startText={formatMessage({
                        id: 'coupon.writeoff.n01.rdo01',
                      })}
                      endText={formatMessage({
                        id: 'coupon.writeoff.n01.rdo03',
                      })}
                      defaultStartDate={null}
                      defaultEndDate={null}
                      rp={rp}
                      setValue={setValue}
                      onChange={() =>
                        // {
                        //  startDate, endDate, reset
                        //  }
                        {
                          setIsReset(false);
                        }
                      }
                      // name="custom-form-submit-name"
                      isReset={isReset}
                    />
                  )}
                  name="date"
                  control={control}
                />
              </FormControl>
              <Controller
                render={(rp) => (
                  <TextField
                    name="mobile"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label={formatMessage({ id: 'coupon.writeoff.n01.lbl04' })}
                    value={rp.value ?? mobileValue}
                    defaultValue={''}
                    onChange={(e) => {
                      setValue('mobile', e.target.value);
                      setMobileValue(e.target.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('mobile', '');
                              setMobileValue('');
                            }}
                            edge="end"
                          >
                            {mobileValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="mobile"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label={formatMessage({ id: 'coupon.writeoff.n01.lbl04' })}
                defaultValue={''}
              />
              {/* <Controller
                render={(rp) => (
                  <TextField
                    name="couponId"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label="优惠券ID"
                    defaultValue={''}
                    onChange={(e) => {
                      setCouponIdValue(e.target.value);
                      setValue('couponId', e.target.value);
                    }}
                    value={rp.value ?? couponIdValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('couponId', '');
                              setCouponIdValue('');
                            }}
                            edge="end"
                          >
                            {couponIdValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="couponId"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label="优惠券ID"
                defaultValue={''}
              /> */}
              <FormControl variant="standard">
                <Controller
                  render={(rp) => (
                    <DateRangePickerML
                      label="发券时间"
                      startText={formatMessage({
                        id: 'coupon.writeoff.n01.rdo05',
                      })}
                      endText={formatMessage({
                        id: 'coupon.writeoff.n01.rdo06',
                      })}
                      defaultStartDate={null}
                      defaultEndDate={null}
                      rp={rp}
                      setValue={setValue}
                      onChange={() =>
                        // {
                        //  startDate, endDate, reset
                        //  }
                        {
                          setSendReset(false);
                        }
                      }
                      // name="custom-form-submit-name"
                      isReset={sendReset}
                    />
                  )}
                  name="sendDate"
                  control={control}
                />
              </FormControl>
              <Controller
                render={(rp) => (
                  <TextField
                    name="cardCode"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    value={rp.value ?? cardCodeValue}
                    onChange={(e) => {
                      setValue('cardCode', e.target.value);
                      setCardCodeValue(e.target.value);
                    }}
                    label={formatMessage({ id: 'coupon.writeoff.n01.lbl07' })}
                    defaultValue={''}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setCardCodeValue('');
                              setValue('cardCode', '');
                            }}
                            edge="end"
                          >
                            {cardCodeValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="cardCode"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label={formatMessage({ id: 'coupon.writeoff.n01.lbl07' })}
                defaultValue={''}
              />
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleReset}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'coupon.writeoff.n01.btn08' })}
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: 'btn_coupon_center_coupon_verification_details_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'coupon.writeoff.n01.btn09' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
};
export default SearchGroup;
